import React, { FC } from 'react';
import Image from 'next/image';
import { LeaderboardReward } from '@wwe-portal/entities/rbe.type';

import { cn } from '@wwe-portal/ui/lib/lib';
import { RewardItemUI } from '../../../../../packages/ui/features/reward/reward-item';

export const RewardItem: FC<{
  rewardItem: Partial<LeaderboardReward>;
  size?: 'default' | 'large';
  position?: 'default' | 'center';
  itemClassName?: string;
  containerClassName?: string;
}> = ({ rewardItem, size, position, itemClassName, containerClassName }) => {
  return (
    <RewardItemUI
      rewardItem={rewardItem}
      inGameItem={
        rewardItem.rewardInGameItem &&
        rewardItem.rewardInGameItem.offerImageUrl ? (
          <Image
            src={rewardItem.rewardInGameItem.offerImageUrl}
            alt={
              rewardItem.rewardInGameItem.offerDisplayName ?? 'unknown reward'
            }
            fill
            aria-label={rewardItem.rewardInGameItem.offerDisplayName}
            className={cn(
              'h-full w-full object-contain object-bottom',
              itemClassName
            )}
          />
        ) : null
      }
      position={position}
      size={size}
      containerClassName={containerClassName}
    />
  );
};
